import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import IndividualClassAttendance from "./routes/IndividualClassAttendance";

export default store => {
  return {
    path: "class",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "class" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [IndividualClassAttendance(store)],
  };
};
